import { render } from "./UpdateUser.vue?vue&type=template&id=1e5769ea&scoped=true&ts=true"
import script from "./UpdateUser.vue?vue&type=script&lang=ts"
export * from "./UpdateUser.vue?vue&type=script&lang=ts"

import "./UpdateUser.vue?vue&type=style&index=0&id=1e5769ea&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DangKyKB_HV/DKKB_new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5769ea"]])

export default __exports__